import React from "react";
import { Row } from "antd";
import useProcuringEntityPackage from "../../../hooks/useProcuringEntityPackage";
import ActionBar from "../../components/ActionBar";
import Loader from "../../Packages/componets/Loader";

const CSCRolesActivities = (packageId) => {
  
  const { loading } = useProcuringEntityPackage(packageId);
  if (loading) {
    return <Loader flexDirection="column" fontSize={54} />;
  }

  return (
    <div style={{ padding: "24px", backgroundColor: "#f0f2f5" }}>
      {/* Page Heading */}
      

  
    </div>
  );
};

export default CSCRolesActivities;
